import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetDetailCatShiftFailed,
  actGetDetailCatShiftSuccess,
  MASTER_GET_DETAIL_CAT_SHIFT,
} from '../../actions/cat-shift'
import { apiGetDetailCatShift } from '../../apis/cat-shift'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDetail(action) {
  try {
    const response = yield call(apiGetDetailCatShift, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actGetDetailCatShiftSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetDetailCatShiftFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetDetail() {
  yield takeLatest(MASTER_GET_DETAIL_CAT_SHIFT, doGetDetail)
}
